import { publishUserInfo } from '@/postMessage'

import loginHandlerV2 from '@/service/login/loginHandlerV2'
import EventEmit from '@/utils/EventEmit'

export default async ({ code, loginType } = {}) => {
  if (!code) {
    publishUserInfo({
      resp_common: { ret: -100, msg: 'request fail' },
      data: {
        login_type: loginType,
      },
    })
    return
  }
  let res = await loginHandlerV2({ code, loginType })

  res = Object.assign({}, { data: { login_type: '' } }, res)
  res.data.login_type = loginType

  publishUserInfo(res)
  EventEmit.$emit('LOGIN', res)
}
